export const CLOUDINARY_VERSION = 'v1658728537'

export const getUrl = (name: string, ext: string = 'png') =>
  `https://res.cloudinary.com/appbuilder/image/upload/${CLOUDINARY_VERSION}/Images/${name}.${ext}`
